var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExternalArticle = function SvgIconExternalArticle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#BDF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 20.375h1.875M26 24.125h1.875m-9.375 3.75h9.375m-9.375 3.75h9.375m3.75-11.25h4.219c.776 0 1.406.63 1.406 1.406V33.5a2.813 2.813 0 0 1-2.813 2.813m-2.812-15.938V33.5a2.813 2.813 0 0 0 2.813 2.813m-2.813-15.938v-3.281c0-.777-.63-1.407-1.406-1.407H16.156c-.776 0-1.406.63-1.406 1.407V33.5a2.813 2.813 0 0 0 2.813 2.813h16.875M18.5 20.374h3.75v3.75H18.5v-3.75Z",
    stroke: "#726D83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconExternalArticle;